import { useMutation } from "react-query";
import { deleteEducationHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useDeleteEducationHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteEducationHistory(id),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while deleting the education history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    deleteEducationHistoryMutation: mutate,
    isDeleteEducationHistoryLoading: isLoading,
    ...rest,
  };
};

export default useDeleteEducationHistory;
